import React from 'react';

interface PosterSlogansSectionProps {
  text: string;
  onChange: (v: string) => void;
  onSave: () => void;
  saving: boolean;
  msg: { type: 'success' | 'error'; text: string } | null;
}

/**
 * 推荐海报宣传标语编辑器（管理员）。
 * text 为 JSON 数组字符串：[{"label": "对外正式版", "text": "..."}]
 */
export default function PosterSlogansSection({ text, onChange, onSave, saving, msg }: PosterSlogansSectionProps) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 mb-6">
      <h3 className="text-sm font-semibold text-gray-800 mb-3">推荐海报宣传标语</h3>
      <p className="text-xs text-gray-400 mb-2">
        生成「推荐有礼」海报时复用的宣传标语。JSON 数组格式，每项含 label（按钮显示名）与 text（海报正文）：
      </p>
      <pre className="text-[11px] text-gray-500 bg-gray-50 border border-gray-100 rounded p-2 mb-2 overflow-x-auto">
        {'[{"label": "对外正式版", "text": "从容投标，稳稳赢标——WinBid。"}]'}
      </pre>
      <textarea
        value={text}
        onChange={(e) => onChange(e.target.value)}
        spellCheck={false}
        rows={10}
        className="w-full font-mono text-xs border border-gray-300 rounded-lg p-3 leading-relaxed resize-y outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        placeholder='[{"label": "对外正式版", "text": "从容投标，稳稳赢标——WinBid。"}]'
      />
      <div className="mt-3 flex items-center gap-3">
        <button
          onClick={onSave}
          disabled={saving}
          className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg disabled:opacity-60 transition-colors"
        >
          {saving ? '保存中...' : '保存标语配置'}
        </button>
        {msg && (
          <span className={`text-xs ${msg.type === 'success' ? 'text-green-600' : 'text-red-500'}`}>
            {msg.text}
          </span>
        )}
      </div>
    </div>
  );
}
